import { useRuntimeConfig } from '../internal';

export function useViewerCountry(): string | undefined {
  return useRuntimeConfig().viewerCountry;
}
